<h3 mat-dialog-title class="title">
    {{ 'store.grid.orderingStatus.title' | translate }}
</h3>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="FormError"
                 *ngIf="showFormError">
        {{ 'form.error.formInvalidMsg' | translate }}
    </txp-message>
</div>

<mat-dialog-content>
    <div class="content">

        <div> {{ 'store.grid.orderingStatus.deactivationReasonMsg' | translate}} {{ data.suffix }}</div>

        <form [formGroup]="form" class="reasons-container">

            <mat-form-field class="reason">
                <mat-label>{{ 'store.grid.orderingStatus.reasonSelect' | translate }}</mat-label>
                <mat-select matInput
                            data-qa-label="Reason"
                            formControlName="reason">
                    <mat-option *ngFor="let reason of reasons" [value]="reason">
                        {{ 'store.grid.aggregatorSummary.' + reason | translate }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('reason').invalid && form.get('reason').hasError('required')">
                    {{ 'form.error.required' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="details" *ngIf="form.get('reason').value === 'other'">
                <mat-label>{{ 'store.grid.orderingStatus.details' | translate }}</mat-label>
                <input formControlName="details"
                       data-qa-label="DetailsInput"
                       required
                       matInput />
                <mat-error *ngIf="form.get('details').invalid && form.get('details').hasError('required')">
                    {{ 'form.error.required' | translate }}
                </mat-error>
            </mat-form-field>

        </form>

    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <txp-button [style]="buttonStyle.PRIMARY"
                [disabled]="isLoading"
                data-qa-label="CloseButton"
                (click)="onClose()">
        {{ 'form.button.close' | translate }}
    </txp-button>

    <txp-button [style]="buttonStyle.PRIMARY"
                [disabled]="isLoading"
                data-qa-label="CloseButton"
                (click)="onConfirm()">
        {{ 'form.button.confirm' | translate }}
    </txp-button>
</mat-dialog-actions>